import React, { Component } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import Input from '../../Shared/Input';
import RejectModal from '../../Shared/TranspotationRejectModal';
import '../../../css/GenericServices/QuotationDetailsGS.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import unchecked from '../../../Assets/TruckVisits/Assets/unchecked-box.svg';
import checked from '../../../Assets/NominateRequest/selectedCheckBox.svg';
import download from '../../../Assets/TruckVisits/Assets/download.svg';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import info_outline from '../../../Assets/UserAccess/Desktop/info-outline.svg';
import edit from '../../../Assets/ProfileManagement/Assets-Desktop/edit.svg';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL } from '../../../Services/config/apiGateway';
import { SERVICE_REQUEST_ENDPOINT, ALLANNOUNCEMENTS_ENDPOINT, SERVICE_RESOLVE_QUOTE_ENDPOINT, SERVICE_CANCELLATION_POLICY_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { toast } from "react-toastify";
import { AES, enc } from 'crypto-js';
import { connect } from 'react-redux';
class QuotationDetailsGS extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            serviceIdValue: '',
            quotationIdValue: '',
            respondentIdValue: '',
            serviceNameValue: '',
            serviceStatusValue: '',
            CompanyName: '',
            Location: '',
            EmailAddress: '',
            MobileNumber: '',
            QuotePrice: '',
            Comments: '',
            UploadDocuments: "",
            CancellationRefundPolicy: '',
            AcceptCancellationRefundpolicy: false,
            AcceptQuotationFlag: false,
            showContinue: false,
            showUpdate: true,
            updateServiceRequest: true,
            RFQStatusOpen: false,
            hasOPenReject: false,
            reason: '',
            reasonTextLimit: 0,
            penaltyDescriptionValue: '',
            errors: []
        }
       // this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount = () => {
     //   document.addEventListener("mousedown", this.handleClickOutside);
        const { serviceId, quotationId, respondentId, serviceName, serviceStatus } = this.props.match.params;
        this.setState({
            serviceIdValue: serviceId, quotationIdValue: quotationId,
            serviceNameValue: serviceName,
            respondentIdValue: respondentId,
            serviceStatusValue: serviceStatus
        });
        if (serviceStatus == "RFQ-Opened" || serviceStatus == "Open") {
            this.setState({
                AcceptQuotationFlag: true,
                showUpdate: false
            });
        } else if (serviceStatus == "Approved" || serviceStatus == "Accepted") {
            this.setState({
                showContinue: true
            });
        }
        if (!this.props.history.location.state) {
            this.getQuotationReceivedDetails(serviceId, quotationId);
        } else {
            this.setState({
                QuotePrice: this.props.history.location.state.quotationAmount,
                Comments: this.props.history.location.state.comments,
                CancellationRefundPolicy: this.props.history.location.state.cancellationPolicy,
                UploadDocuments: this.props.history.location.state.docPath,
                CompanyName: this.props.history.location.state.companyName,
                Location: this.props.history.location.state.location,
                EmailAddress: this.props.history.location.state.email,
                MobileNumber: this.props.history.location.state.mobileNumber,
            }
            )
            this.getCancellationPolicyData()
        }
    }
    getCancellationPolicyData = () => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_CANCELLATION_POLICY_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    apiData?.every((md, index) => {
                        if (this.state.CancellationRefundPolicy == md?.basePenalty?.penaltyName) {
                            this.setState({
                                penaltyDescriptionValue: md?.basePenalty?.penaltyDescription
                            })
                            return false
                        }
                        return true
                    })
                }
            }
        });
    }
    getQuotationReceivedDetails = (serviceId, quotationId) => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_REQUEST_ENDPOINT + `?roleType=${this.props.manageProfileDataR?.selectedProfileType}&serviceRequestId=${serviceId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    apiData?.respondents?.otherRespondents.find((name) => {
                        if (name.quotationId == quotationId) {
                            console.log("ddddddddddddddddd", name.quotationId);
                            this.setState({
                                QuotePrice: name.quotationAmount,
                                Comments: name.comments,
                                CancellationRefundPolicy: name.cancellationPolicy,
                                UploadDocuments: name.docPath,
                                CompanyName: name.companyName,
                                Location: name.location,
                                EmailAddress: name.email,
                                MobileNumber: name.mobileNumber,
                            }
                            )
                            this.getCancellationPolicyData()
                        }
                    });
                }
            }
        });
    }
    toggleCancellationRefundpolicyChek = () => {
        this.setState({ AcceptCancellationRefundpolicy: !this.state.AcceptCancellationRefundpolicy })
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleContinue = () => {
        if (this.handleValidation()) {
            this.props.history.push({
                pathname: `/PaymentProcessTransportation/${this.state.quotationIdValue}`
            })
        }
    }
    handleAccept = () => {
        if (this.handleValidation() && this.state.AcceptCancellationRefundpolicy) {
            ApiCall(
                'PUT',
                serviceBaseURL + SERVICE_RESOLVE_QUOTE_ENDPOINT,
                {
                    "serviceRequestId": parseInt(this.state.serviceIdValue),
                    "quoteId": parseInt(this.state.quotationIdValue),
                    "respondentId": parseInt(this.state.respondentIdValue),
                    "resolution": "Accepted",
                    "comments": ""
                },
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            ).then(data => {
                if (data.flag != -1) {
                    if (data.flag == '500') {
                        console.log('I am 500!');
                    } else {
                        console.log('I am 200!');
                        this.setState({
                            AcceptQuotationFlag: false,
                            showContinue: true,
                            showUpdate: true
                        });
                    }
                }
                else {
                    console.log('Something went wrong!');
                }
            });
        } else if (!this.state.AcceptCancellationRefundpolicy) {
            toast("Please accept the cancellation & refund policy.", { position: toast.POSITION.TOP_CENTER, style: { color: "red" } });
        }
    }
    handleReject = () => {
        this.setState({ hasOPenReject: true });
    }
    ValidateRejection = () => {
        let isValid = true
        let errors = {};
        if (!this.state.reason) {
            isValid = false
            errors["RejectComment"] = Message.validation.required;
            document.getElementsByName('RejectComment')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('RejectComment')[0].style.borderColor = ColorCode.colorCode.black;
          
        }
        this.setState({ errors: errors });
        return isValid;
    };
    onCloseReject =()=>{
        if(this.ValidateRejection()){
            ApiCall(
                'PUT',
                serviceBaseURL + SERVICE_RESOLVE_QUOTE_ENDPOINT,
                {
                    "serviceRequestId": parseInt(this.state.serviceIdValue),
                    "quoteId": parseInt(this.state.quotationIdValue),
                    "respondentId": parseInt(this.state.respondentIdValue),
                    "resolution": "Rejected",
                    "comments": this.state.reason
                },
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            ).then(data => {
                if (data.flag != -1) {
                    if (data.flag == '500') {
                        console.log('I am 500!');
                    } else {
                        console.log('I am 200!');
                       this.setState({ hasOPenReject: false });
                       this.props.history.push({
                        pathname :`/QuotationHistory`
                    })
                    }
                }
                else {
                    console.log('Something went wrong!');
                }
            });
        }
    }
    handleChangeComment = (e) => {
        if (e.target.value.length <= 50) {
            this.setState({ reasonTextLimit: e.target.value.length });
            this.setState({ reason: e.target.value });
            this.setState({
                errors: {
                    ...this.state.errors,
                    RejectComment: ''
                }
            });
            document.getElementsByName('RejectComment')[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    updateServiceRequestFunction = () => {
        this.props.history.push({
            pathname: `/UpdateServiceRequestGS/${this.state.serviceIdValue}/${this.state.serviceNameValue}`
        })
    }
    handleContainerDetails = () => { }
    handlePaymentDetails = () => { }
    render() {
        return (
            <div class="QuotationDetailsOutercolor">
                <MetaDecorator title={TitleDescription.QuotationDetailsGSTitle} description={TitleDescription.QuotationDetailsGSDescription} />
                <Header tilesFetched={() => { }} />
                <div class="QuotationDetailsOuterDivcss">
                    <div id="QuotationDetailsBoxDiv">
                        <nav class="QuotationDetailsNavbar">
                            <div className="QuotationDetailsNavbarName">
                                <small id="QuotationDetailsNavbarText">{this.state.serviceNameValue}</small>
                            </div>
                            {this.state.showUpdate &&
                                <div id="QuotationCDetailsGSAcceptMobile" className="QuotationCDetailsGSNavbarNameRight">
                                    <small
                                        class="QuotationCDetailsGSNavbarRightText"
                                        onClick={this.updateServiceRequestFunction}>
                                        Update Service Request
                                    </small>
                                </div>
                            }
                        </nav>
                        <hr class="hr1" />
                        {this.state.showUpdate && <>
                            <nav class="QuotationCDetailsGSMobileNavbar">
                                <div className="QuotationCDetailsGSNavbarNameRight">
                                    <small
                                        class="QuotationCDetailsGSNavbarRightText"
                                        onClick={this.updateServiceRequestFunction}>
                                        Update Service Request
                                    </small>
                                </div>
                            </nav>
                            <hr class="hrGSMobile" />
                        </>}
                        <div class="QuotationDetailsMidPartition">
                            <div class="QuotationDetailsHeadingText">Respondent Details</div>
                            <div class="QuotationDetailsCardcss">
                                <div class="QuotationDetailsInpSize">
                                    <small id="QuotationDetailsInpHeading">Company Name</small>
                                    <div class="QuotationDetailsLowerText">{this.state.CompanyName}</div>
                                </div>
                                <div class="QuotationDetailsInpSize">
                                    <small id="QuotationDetailsInpHeading">Location</small>
                                    <div class="QuotationDetailsLowerText">{this.state.Location}</div>
                                </div>
                                <div class="QuotationDetailsInpSize">
                                    <small id="QuotationDetailsInpHeading">Email Address</small>
                                    <div class="QuotationDetailsLowerText">{this.state.EmailAddress}</div>
                                </div>
                                <div class="QuotationDetailsInpSize">
                                    <small id="QuotationDetailsInpHeading">Mobile Number</small>
                                    <div class="QuotationDetailsLowerText">{this.state.MobileNumber}</div>
                                </div>
                            </div>
                            <div class="QuotationDetailsCardLwrText">Company details will be revealed once you <small class="QuotationDetailsCardLwrBold">Accept</small> the response and make the payment.</div>
                            <div class="QuotationDetailsHeadingText">Respondent Response</div>
                            <div class="QuotationDetailsCardcss">
                                <div class="QuotationDetailsInpSize">
                                    <small id="QuotationDetailsInpHeading">Quote Price (Inclusive of Taxes)</small>
                                    <div class="QuotationDetailsLowerText"><small class="QuotationDetailsLowerBold">R</small>{this.state.QuotePrice}</div>
                                </div>
                                <div class="QuotationDetailsInpSize">
                                    <small id="QuotationDetailsInpHeading">Comments (Optional)</small>
                                    <div class={this.state.Comments === '' ? "QuotationDetailsNAText" : "QuotationDetailsLowerText"}>
                                        {this.state.Comments === '' ? "No Comments" : this.state.Comments}
                                    </div>
                                </div>
                                <div class="QuotationDetailsInpSize">
                                    <small id="QuotationDetailsInpHeading">Upload Documents (Optional)</small>
                                    {this.state.UploadDocuments?.length > 0
                                        ?
                                        <div class="TransportationServiceRUploaddocText">{this.state.UploadDocuments?.split('/')[11]?.split("'")[0]}</div>
                                        :
                                        <div class="QuotationDetailsNoDocU">No document uploaded</div>
                                    }
                                </div>
                                <div class="QuotationDetailsInpSize">
                                    <small class="QuotationDetailstooltip2" id="QuotationDetailsInpHeading">
                                        <div class="QuotationDetailstooltipouter">
                                            <span class="QuotationDetailstooltiptext">
                                                <div class="QuotationDetailstooli01">
                                                    <div class="QuotationDetailsTooltipLowerText">{this.state.CancellationRefundPolicy}</div>
                                                    <small id="QuotationDetailsTooltipDataHeading">{this.state.penaltyDescriptionValue}</small>
                                                </div>
                                            </span>
                                        </div>
                                        Cancellation & Refund Policy
                                        <img id="QuotationDetailsInfo_img" src={info_outline} />
                                    </small>
                                    <div class="QuotationDetailsLowerText">{this.state.CancellationRefundPolicy}</div>
                                </div>
                            </div>
                            {
                                this.state.RFQStatusOpen &&
                                <div class="QuotationDetailsContainerPayDiv">
                                    <div class="QuotationDetailsContainerDivcss" onClick={this.handlePaymentDetails}>
                                        <small class="QuotationDetailsContainerPayText">Payment Details</small>
                                        <img id=""
                                            src={rightarrow}
                                        />
                                    </div>
                                </div>
                            }
                            {
                                this.state.AcceptQuotationFlag &&
                                <>
                                    <div class="QuotationDetailsCheckdiv">
                                        <img id=""
                                            src={this.state.AcceptCancellationRefundpolicy ? checked : unchecked}
                                            onClick={this.toggleCancellationRefundpolicyChek}
                                        />
                                        <div class="QuotationDetailsChecktext">I accept the cancellation & refund policy.</div>
                                    </div>
                                    <div class="QuotationDetailsBtnDiv">
                                        <Button class="QuotationDetailsBtnCss" onClick={this.handleAccept}>
                                            <small class="QuotationDetailsBtntext">Accept</small>
                                        </Button>
                                        <Button class="QuotationDetailsRejectBtnCss" onClick={this.handleReject}>
                                            <small class="QuotationDetailsRejectBtntext">Reject</small>
                                        </Button>
                                    </div>
                                </>
                            }
                            {this.state.showContinue &&
                                <>
                                    <div class="QuotationDetailsDownloadCardcss">
                                        <small class="QuotationDetailsDownloadtext">Download Invoice</small>
                                        <img id=""
                                            src={download}
                                        />
                                    </div>
                                    <div id='QuotationDetailsonBtnDiv' class="QuotationDetailsBtnDiv">
                                        <Button class="QuotationDetailsBtnCss" onClick={this.handleContinue}>
                                            <small class="QuotationDetailsBtntext">Continue</small>
                                        </Button>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
                <div class="QuotationDetailsFooterUnfixed">
                    <Footer />
                </div>
                <div class="QuotationDetailsFooterFixed">
                    <Footer2 />
                </div>
                {this.state.hasOPenReject ? <RejectModal hasOpen={this.state.hasOPenReject} onCloseModal={this.onCloseReject} >
                    <div>
                        <div class="successtext1outercreatepreadvise">
                            <small class="rejectModalHeading">Do you want to reject this response?</small>
                        </div>
                        <div class="rejectMainDiv">
                            <div className="pass-wrapper" id="rejectInputDiv" >
                                <Input
                                    name="RejectComment"
                                    class="input" placeholder="Please enter your reason"
                                    type="text" id="CrtTptReqestInpCss" value={this.state.reason}
                                    onChange={this.handleChangeComment}
                                />
                                <i id="rejectInputIcon">
                                    <img src={edit} />
                                </i>
                                <div className="QuotationDetailsDropError">{this.state.errors["RejectComment"]}</div>
                                <small class="inpsmallraise">{this.state.reasonTextLimit}/50</small>
                            </div>
                        </div>
                    </div>
                </RejectModal> : null}
            </div >
        );
    }
}
function mapStateToProps(state) {
    return {
        manageProfileDataR: state.manageProfileReducer.data
    }
}
export default connect(mapStateToProps)(QuotationDetailsGS);
